import { render, staticRenderFns } from "./DiscrepanciesDonutBySupplier.vue?vue&type=template&id=a0229364"
import script from "./DiscrepanciesDonutBySupplier.vue?vue&type=script&lang=js"
export * from "./DiscrepanciesDonutBySupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports